import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./quasar"
import Vuelidate from 'vuelidate'
import mixins from "@/plugins/mixins"
import filters from "@/plugins/filters"
import Axios from 'axios'
import apiEndpoints from "./api/api-endpoints"
import reCaptchaPlugin from '@/plugins/vue-recaptcha-v3';

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
Vue.prototype.$http = Axios
const token = JSON.parse(localStorage.getItem('token'))
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token?.access_token
}

Vue.use(Vuelidate)
Vue.use(mixins)
Vue.use(filters)
Vue.use(reCaptchaPlugin);
Vue.config.productionTip = false

if (!process.env.VUE_APP_ISTESTSITE) {
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
}

Vue.config.errorHandler = function (err, vm, info) {
    try {
        // handle error
        // `info` is a Vue-specific error info, e.g. which lifecycle hook
        // the error was found in. Only available in 2.2.0+
        //console.log(err)
        //console.log(vm)
        //console.log(info)

        const componentTrace = getComponentTrace(vm);

        const errorPayload = {
            message: err?.message || 'Unknown error',
            stack: err?.stack || 'No stack trace',
            info: info || 'No Vue info',
            component: vm?.$options?.name || vm?.$options?._componentTag || 'anonymous',
            componentTrace: componentTrace || [],
            propsData: vm?.$options?.propsData || {},
            route: vm?.$route?.fullPath || 'unknown',
            startLocation: vm?.$router?.history._startLocation || 'unknown',
            customContext: err?._customContext,
            userAgent: navigator.userAgent,
            time: new Date().toISOString()
        };

        Axios.post(apiEndpoints.notifyError, { 'data': errorPayload })
            .then(response => {
                console.log('Error reported:', response);
            })
            .catch(reportError => {
                console.error('Failed to report error:', reportError);
            });

        router.push('/error');
    } catch (handlerError) {
        const errorPayload = {
            'Error in errorHandler': handlerError.message || 'Unknown error',
            'Original error': err?.message || 'Unknown error',
        };
        Axios.post(apiEndpoints.notifyError, { 'data': errorPayload })
    }
};

function getComponentTrace(vm) {
    const trace = [];
    try {
        let current = vm;
        while (current) {
            const name = current?.$options?.name || current?.$options?._componentTag || 'anonymous';
            trace.push(name);
            current = current.$parent;
        }
    } catch (e) {
        trace.push('Error generating trace');
    }
    return trace;
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#q-app")
